import { Store } from "redux";
import { startLoadingState, endLoadingState, loadingTemplate } from "../../components/ticketing/basket-v2/basketLoading";
import { Discount } from "./discount";
import { AdditionalCosts } from "./additional-costs";
import { logError, reportError } from "../../components/ticketing/basket-v2/errorReporting";
import { constants } from "../../components/ticketing/common";
import { EventEmitter, postJsonWithResponse } from "../../utils";
import { events } from "../constants";
import { classes } from "../constants";

export class OrderSummary {
  element: HTMLElement | null;
  //discountTotalElement: HTMLElement;
  orderTotals: NodeListOf<HTMLElement>;
  store: Store;
  promo: Discount<{ amount: number }>;
  vouchers: Discount<{ amount: number }>;
  rewards4Racing: Discount<{ amount: number }>;
  additionalCosts: AdditionalCosts;
  checkoutPageId: HTMLInputElement | null;
  defaultError = { code: 0, message: "Error refreshing order summary" };
  orderSummarySelector: string;
  paymentDetailsSection: HTMLElement;
  loadingStoreChangeMessage: string;

  constructor(selector: string, store: Store) {
    this.orderSummarySelector = selector;
    this.element = document.querySelector(selector);
    this.store = store;
    this.checkoutPageId = document.querySelector("#checkoutPageId");
    this.paymentDetailsSection = document.querySelector("#payment-details-section");
    this.loadingStoreChangeMessage = loadingTemplate("Please wait");

    if (!this.element) return;

    this.promo = new Discount("[data-discount-promo]", store, (state) => (state as any).promo);
    this.vouchers = new Discount("[data-discount-voucher]", store, (state) => (state as any).vouchers);
    this.rewards4Racing = new Discount("[data-discount-rewards4racing]", store, (state) => (state as any).rewards4Racing);

    this.orderTotals = document.querySelectorAll("[data-order-total]");
    this.additionalCosts = new AdditionalCosts("[data-delivery-cost]", store);

    this.bindEvents();
  }

  bindEvents() {
    this.store.subscribe(this.handleStoreChange);
  }

  handleStoreChange = async () => {
    try {
      startLoadingState(this.loadingStoreChangeMessage, ".basket-overlay");

      let summaryRequest = {
        checkoutPageId: parseInt(this.checkoutPageId?.value ?? "0"),
      };

      const summaryResponse = await postJsonWithResponse(constants.urls.basketV2.checkout_summary, summaryRequest);

      if (!summaryResponse.ok) {
        reportError(0, "An error occurred refreshing order summary");
        endLoadingState(".basket-overlay");
        return;
      }

      if (this.element) {
        this.element.outerHTML = await summaryResponse.text();
        this.element = document.querySelector(this.orderSummarySelector);

        if (this.element) {
          const orderTotal = this.element.querySelector("[data-order-total]")?.innerHTML ?? "0.00";

          if (this.paymentDetailsSection != null) {
            if (orderTotal === "0.00") {
              this.paymentDetailsSection.classList.add(classes.HIDDEN);
            } else {
              this.paymentDetailsSection.classList.remove(classes.HIDDEN);
            }
          }

          this.orderTotals.forEach((orderTotalElement) => {
            orderTotalElement.innerHTML = orderTotal;
          });

          const updateResponse = await fetch(constants.urls.payment.update, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
          });

          if (!updateResponse.ok) {
            const errMsg = "There was an error updating payment in response to basket change";
            logError(updateResponse.status, updateResponse.statusText, errMsg);
          }

          EventEmitter.emit(events.ORDER_UPDATE_END);
        }
      }
    } catch (e) {
      console.log(e);
      reportError(this.defaultError.code, e.message ?? this.defaultError.message);
      endLoadingState(".basket-overlay");
    }
  };
}
